import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (CFT150 / FT151 / CFT152 / FT153)
// ============================================================

export interface FT153 {
  ft153_01: string;        // 會議代號 (FK)
  ft153_02: number;        // 議題序號 (FK)
  ft153_03: number;        // 追蹤序號
  ft153_11: string;        // 追蹤事項
  ft153_12: string | null; // 預計完成日期
  ft153_13: string;        // 處理說明
  ft153_14: string | null; // 實際完成日期
  ft153_15: string;        // 負責人員工號
  ft153_15a: string;       // 負責人姓名
  ft153_16: string;        // 部門代號
  ft153_16a: string;       // 部門名稱
}

export interface CFT152 {
  ft152_01: string;        // 會議代號 (FK)
  ft152_02: number;        // 序號
  ft152_11: string;        // 議題內容
  ft152_12: string;        // 討論結果
  ft152_91: string;        // 修改人
  ft152_92: string | null; // 修改時間
  ft152_93: string;        // 建立人
  trackings?: FT153[];
}

export interface FT151 {
  ft151_01: string;        // 會議代號 (FK)
  ft151_02: number;        // 序號
  ft151_11: string;        // 員工代號
  ft151_11a: string;       // 員工姓名
  ft151_12: string;        // 部門代號
  ft151_12a: string;       // 部門名稱
  ft151_13: string;        // 職稱 / 簽到時間
  ft151_14: string;        // 出席狀態 / 簽退時間
  ft151_91: string;        // 修改人
  ft151_92: string | null; // 修改時間
  ft151_93: string;        // 建立人
}

export interface CFT150 {
  ft150_01: string;        // 會議代號
  ft150_11: string;        // 會議名稱
  ft150_12: string;        // 說明 (TEXT/editbox)
  ft150_13: string | null; // 會議日期
  ft150_14: string;        // 開始時間
  ft150_15: string;        // 結束時間
  ft150_16: string;        // 會議地點
  ft150_17: string;        // 開會通知單號
  ft150_18: number;        // 與會人數
  ft150_19: number;        // 議題數
  ft150_20: string;        // 部門
  ft150_21: string;        // 開會通知單號
  ft150_22: string;        // 記錄人員工號
  ft150_24: string;        // 開會部門
  ft150_91: string;        // 修改人
  ft150_92: string | null; // 修改時間
  ft150_93: string;        // 建立人
  attendees?: FT151[];
  topics?: CFT152[];
  trackings?: FT153[];
}

export interface ListResponse {
  data: CFT150[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface CreateRequest {
  master: Partial<CFT150>;
  attendees: Partial<FT151>[];
  topics: Partial<CFT152>[];
  trackings: Partial<FT153>[];
}

// ============================================================
// API Client
// ============================================================

const BASE = '/api/pwt205';

export const pwt205Api = {
  list: async (page = 1, size = 20, keyword = ''): Promise<ListResponse> => {
    const res = await apiClient.get(BASE, { params: { page, size, keyword } });
    return res.data;
  },

  get: async (id: string): Promise<CFT150> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  create: async (
    master: Partial<CFT150>,
    attendees: Partial<FT151>[],
    topics: Partial<CFT152>[],
    trackings: Partial<FT153>[],
  ): Promise<CFT150> => {
    const res = await apiClient.post<CFT150>(BASE, { master, attendees, topics, trackings });
    return res.data;
  },

  update: async (
    id: string,
    master: Partial<CFT150>,
    attendees: Partial<FT151>[],
    topics: Partial<CFT152>[],
    trackings: Partial<FT153>[],
  ): Promise<CFT150> => {
    const res = await apiClient.put<CFT150>(`${BASE}/${encodeURIComponent(id)}`, {
      master,
      attendees,
      topics,
      trackings,
    });
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
